import React from 'react';
import { useI18n } from '@/i18n/index.jsx';

export const generateOrganizationSchema = (isEN) => {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "TudoConversor",
    "url": "https://tudoconversor.com.br",
    "logo": "https://tudoconversor.com.br/logo-square.png",
    "foundingDate": "2026-05-09",
    "description": isEN
      ? "TudoConversor is a free online unit conversion platform maintained by a team dedicated to accurate tools based on official BIPM standards. We focus on precision, clarity and educational value for Brazilian and international users."
      : "O TudoConversor é uma plataforma online gratuita de conversão de unidades, mantida por uma equipe dedicada a ferramentas precisas baseadas nos padrões oficiais do BIPM. Focamos em precisão, clareza e valor educacional para usuários brasileiros e internacionais.",
    "sameAs": [
      "https://twitter.com/tudoconversor",
      "https://facebook.com/tudoconversor"
    ]
  };
};

export const generateWebSiteSchema = (isEN) => {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Tudo Conversor",
    "url": "https://tudoconversor.com.br",
    "description": isEN ? "The best and most accurate free online tool for unit conversion." : "A melhor e mais precisa ferramenta online gratuita para conversão de unidades."
  };
};

export const generateBreadcrumbListSchema = (items) => {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": item.url
    }))
  };
};

export default function StructuredData({ data }) {
  const { lang } = useI18n();
  const isEN = lang === 'en';

  if (!data) return null;
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}